// Services
import { fetchCustomerAuthorizationDataService } from '../services/token.service';
// Types
import { TokenApiDataApiResponseType } from '../types/token-api-data-api-response.type';

const fetchCustomerAuthorizationDataResolver = async (
  token: string
): Promise<[TokenApiDataApiResponseType] | [null, true]> => {
  const [response] = await fetchCustomerAuthorizationDataService(token);

  return response?.accessToken ? [response] : [null, true];
};

export { fetchCustomerAuthorizationDataResolver };
